"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["rounded", "maxCount", "size"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var sizes = {
  xs: '!w-8 !h-8',
  sm: '!w-10 !h-10',
  md: '!w-12 !h-12',
  lg: '!w-14 !h-14'
};
var TiledAvatars = function TiledAvatars(_ref) {
  var _ref$rounded = _ref.rounded,
    rounded = _ref$rounded === void 0 ? true : _ref$rounded,
    _ref$maxCount = _ref.maxCount,
    maxCount = _ref$maxCount === void 0 ? 3 : _ref$maxCount,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var sizeClasses = sizes[size] || sizes.md;
  var children = (0, _react.useMemo)(function () {
    var childrenCount = Math.min(_react["default"].Children.count(rest.children), maxCount);

    // Scale the avatar for better fit in the tiling layout
    var scale = childrenCount > 2 ? 1.5 : childrenCount > 1 ? 1.2 : 1;
    return _react["default"].Children.toArray(rest.children).slice(0, maxCount).reverse().reduce(function (memo, curr, index, source) {
      var reversedIndex = source.length - index - 1;
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index,
        className: (0, _classnames["default"])('w-full h-full flex', {
          'flex-col-reverse': reversedIndex % 2 === 1
        })
      }, memo && /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex-1"
      }, memo), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex-1"
      }, /*#__PURE__*/_react["default"].cloneElement(curr, {
        // Don't scale the first avatar
        scale: reversedIndex > 0 ? scale : 1
      })));
    }, null) || /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }, [maxCount, rest.children]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(rest.className, sizeClasses, {
      'rounded-full overflow-hidden': rounded
    })
  }, children);
};
var _default = exports["default"] = TiledAvatars;
//# sourceMappingURL=index.js.map